import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import Api from "lib/api/httpRequestHelper";
import UtilsFncs from "utils/UtilsFncs";
import InputText from "components/_refactor/text/input";
import UploadFile from "components/Dropzone/UploadFile";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import StructureFields from "components/_refactor/fields/structure";
import MonthYearField from "components/_refactor/fields/month-year";
import AcceptDialog from "./accept-dialog";
import { Close } from "@mui/icons-material";
import getMonthByNumber from "utils/get-month-by-number";

const MONTH_INDEX = new Date().getMonth() + 1;
const YEAR = new Date().getFullYear();

export default function DialogCreate({ onClose, handleSearch }) {
  const [structureFilters, setStructureFilters] = useState({});
  const [structureLoading, setStructureLoading] = useState([]);
  const [openAcceptDialog, setOpenAcceptDialog] = useState(false);
  const [name, setName] = useState("");
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [month, setMonth] = useState({
    value: MONTH_INDEX,
    label: getMonthByNumber(MONTH_INDEX),
  });
  const [year, setYear] = useState({ value: YEAR, label: String(YEAR) });
  const [loading, setLoading] = useState(false);

  const snackbar = useSnackbar();

  const handleCreate = async ({ force = false } = {}) => {
    setLoading(true);
    const base64Csv = await UtilsFncs.FileToB64(filesToUpload[0]);
    let encodedBase64 = base64Csv?.toString()?.replace(/^data:(.*,)?/, "");

    if (encodedBase64.length % 4 > 0) {
      encodedBase64 += "="?.repeat(4 - (encodedBase64.length % 4));
    }

    const payload = {
      nomeArquivo: name,
      extensao: filesToUpload[0].name.split(".").pop(),
      arquivo: encodedBase64 ? encodedBase64 : "",
      idPessoaLoja: structureFilters?.idLoja,
      periodo: `${year.value.toString()}-${month.value
        .toString()
        .padStart(2, "0")}-01`,
      force: force,
    };

    try {
      const response = await Api.post(
        "advertising-upload-file",
        "franquias",
        payload,
        true,
      );
      if (response.Success) {
        snackbar.showMessage("Ação criada com sucesso.", {
          severity: "success",
        });
      }
      handleSearch({ page: 0, sizePerPage: 10 });
      onClose();
    } catch (error) {
      if (error.includes("Já existe arquivo para esse período")) {
        setOpenAcceptDialog(true);
      } else {
        snackbar.showMessage(
          "não foi possível criar a ação. Tente novamente.",
          {
            severity: "error",
          },
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog open onClose={onClose} maxWidth="lg">
        <DialogTitle>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h3" color="primary">
              Criar Ação de Fundo de Propaganda
            </Typography>
            <IconButton onClick={onClose}>
              <Close />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <InputText
                label="Nome da Ação"
                value={name}
                required
                onChange={(e) => setName(e.target.value)}
              />
            </Grid>
            <MonthYearField
              month={month}
              handleMonthChange={setMonth}
              year={year}
              handleYearChange={setYear}
              disabled={loading}
              displayEmpty={false}
              md={12}
              lg={12}
              required
              direction="future"
            />
            <StructureFields
              clearFilters={false}
              onStructureFieldsChange={setStructureFilters}
              disableAll={!!structureLoading.length}
              onStructureFieldsLoad={setStructureLoading}
              requiredFields={["store"]}
              hideFields={["brand", "channel", "representative"]}
              handleSearch={() => {}}
              franquias
            />
            <Grid item xs={12}>
              <UploadFile
                accept={[
                  ".pdf",
                  ".doc",
                  ".docx",
                  ".pptx",
                  ".ppt",
                  ".txt",
                  ".jpg",
                  ".png",
                ]}
                onChangeFiles={setFilesToUpload}
                disabled={loading}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => onClose()}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCreate}
            disabled={
              loading ||
              structureLoading.length > 0 ||
              filesToUpload.length === 0 ||
              name === ""
            }
          >
            Criar
          </Button>
        </DialogActions>
      </Dialog>

      {openAcceptDialog && (
        <AcceptDialog
          onClose={() => setOpenAcceptDialog(false)}
          onAccept={() => handleCreate({ force: true })}
          loading={loading}
        />
      )}
    </>
  );
}
